/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */

/**
 * Payment method (支払方法)
 */
export type SearchAdminInvoiceReportsQueryPaymentMethod =
  (typeof SearchAdminInvoiceReportsQueryPaymentMethod)[keyof typeof SearchAdminInvoiceReportsQueryPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SearchAdminInvoiceReportsQueryPaymentMethod = {
  bank_transfer: 'bank_transfer',
  cash: 'cash',
  payment_slip: 'payment_slip',
  direct_debit: 'direct_debit',
  credit_card: 'credit_card',
  prepaid_card: 'prepaid_card',
  check: 'check',
  promissory_note: 'promissory_note',
  densai: 'densai',
  remittance_abroad: 'remittance_abroad',
  other: 'other',
} as const;
